module.exports = __webpack_public_path__ + "fonts/F37Moon-Light.15f318b.otf";